import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import {
  generateReportCall,
  getFdesParametersCall,
  getReferencesCall,
  postFdesResultCall,
  postFdesRealTimeResultCall,
  saveFdesResultCall,
  updateCalculCall,
  getFdesMetaDataCall,
  postFdesUploadFileCall,
  postEDECIntegrationProcess,
  getCalculCall,
  bulkGenerateReportsCall,
  bulkDownloadReportsCall,
} from "../../../APIClient";
import { parseResponse } from "../../../utils/http";
import {
  GET_FDES_PARAMETERS_SUCCESS,
  SAVE_FDES_FORM_FAILED,
  SAVE_FDES_FORM_SUCCESS,
  LOAD_FDES_PARAMETERS,
  SAVE_FDES_FORM,
  SAVE_FDES_FORM_REAL_TIME,
  LOAD_REFERENCE_SUCCESS,
  LOAD_REFERENCE_FAILED,
  LOAD_REFERENCE,
  SAVE_FDES_RESULT,
  SAVE_FDES_RESULT_SUCCESS,
  SAVE_FDES_RESULT_FAILED,
  GENERATE_REPORTS,
  GENERATE_REPORTS_FAILED,
  GENERATE_REPORTS_SUCCESS,
  UPDATE_CALCUL,
  UPDATE_CALCUL_SUCCESS,
  UPDATE_CALCUL_FAILED,
  GET_FDES_METADATA_SUCCESS,
  GET_FDES_METADATA,
  POST_FDES_FILE,
  POST_FDES_FILE_FAILED,
  GET_FDES_METADATA_CALCUL_ROW,
  SEND_XML_TO_EDEC,
  LOAD_CALCUL_DATA_SUCCESS,
  BULK_GENERATE_REPORTS_SUCCESS,
  BULK_GENERATE_REPORTS_FAILED,
  BULK_GENERATE_REPORTS,
  BULK_DOWNLOAD_REPORTS_SUCCESS,
  BULK_DOWNLOAD_REPORTS_FAILED,
  BULK_DOWNLOAD_REPORTS,
  ENABLE_RESULT_FORM_LOADER,
} from "../constants";
import {
  changeFdesParameterForm,
  saveCurrentFdesId,
  clearRecalcAfterUpgrade,
} from "../actions";
import {
  formatFdesParametersPayload,
  formatRealTimeFdesParametersPayload,
  formatFdesResultParametersPayload,
  formatGenerateReportPayload,
  formatFilePayload,
  formatEDECIntegrationProcessPayload,
} from "../../../utils/transformer";
import { toast } from "react-toastify";
import {
  disableDownloadReportsLoader,
  disableReportsLoaders,
  enableDownloadReportsLoader,
  enableReportsLoaders,
} from "../../../common/actions/loader";
import { loadUserCalculs } from "../../calcul/actions";
import { push } from "redux-first-history";
import { loadFolderCalculs } from "../../folders/actions";
import { AFFICHAGERSLT } from "../constants/metadata";

function* getReferences(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);
    const data = yield call(getReferencesCall, token, action.standard);
    yield call(parseResponse, data, LOAD_REFERENCE_SUCCESS);
  } catch (error) {
    yield put({ type: LOAD_REFERENCE_FAILED, error });
  }
}

function* getFdesParameters(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);
    const data = yield call(getFdesParametersCall, token, action.fdesId);
    yield call(parseResponse, data, GET_FDES_PARAMETERS_SUCCESS);
    yield put(saveCurrentFdesId(action.fdesId));

    if (!action.calcul && !action.isEditMode) {
      yield put({
        type: action.api ? SAVE_FDES_FORM_REAL_TIME : SAVE_FDES_FORM,
        api: action.api,
        fdesId: action.fdesId,
      });
    } else {
      if (action.calcul._id) {
        const data = yield call(getCalculCall, token, action.calcul._id);
        yield call(parseResponse, data, LOAD_CALCUL_DATA_SUCCESS);

        // If the calcul was just upgraded, recalculate now that the new
        // parameters and calcul data are loaded, using the right calculator.
        const recalcAfterUpgrade = yield select(
          (state) => state.fdes.recalcAfterUpgrade,
        );
        if (recalcAfterUpgrade) {
          yield put({
            type: action.api ? SAVE_FDES_FORM_REAL_TIME : SAVE_FDES_FORM,
            api: action.api,
            fdesId: action.fdesId,
            saveCalculAfter: true,
            calculId: action.calcul._id,
          });
        }
      }
    }
  } catch (error) {
    yield put({ type: "GET_FDES_PARAMETERS_FAILED", error });
  }
}

function* getFdesMetaData(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);
    const data = yield call(getFdesMetaDataCall, token, action.fdesId);
    yield call(parseResponse, data, GET_FDES_METADATA_SUCCESS);
  } catch (error) {
    yield put({ type: "GET_FDES_PARAMETERS_FAILED", error });
  }
}

function* getFdesMetaDataCalculRow(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);
    const data = yield call(getFdesMetaDataCall, token, action.fdesId);
    data.code === "200" ? action.reject() : console.log(data);
  } catch (error) {
    action.reject();
    yield put({ type: "GET_FDES_PARAMETERS_FAILED", error });
  }
}

function* postFdesResult(action) {
  const getToken = (state) => state.user.informations.token;
  const getFormFields = (state) => state.fdes.form.fields;
  const getSimulationMode = (state) => state.fdes.simulationMode;
  const getMetadata = (state) => state.fdes.metadata;

  try {
    const token = yield select(getToken);
    const fields = yield select(getFormFields);
    const simulationMode = yield select(getSimulationMode);
    const metadata = yield select(getMetadata);
    const metadataList = Array.isArray(metadata) ? metadata : [];

    const affResType = metadataList.find(
      (e) => e.paramId === AFFICHAGERSLT,
    )?.defaultValue;

    const data = yield call(
      postFdesResultCall,
      token,
      formatFdesParametersPayload(
        fields,
        action.fdesId,
        simulationMode,
        affResType === "thermometer",
      ),
    );
    yield call(parseResponse, data, SAVE_FDES_FORM_SUCCESS);
    if (action.saveCalculAfter && action.calculId) {
      yield put({ type: UPDATE_CALCUL, calculId: action.calculId });
      yield put(clearRecalcAfterUpgrade());
    }
  } catch (error) {
    if (action.saveCalculAfter) {
      yield put(clearRecalcAfterUpgrade());
    }
    yield put({ type: SAVE_FDES_FORM_FAILED, error });
  }
}

//action.api: "google" or "apsivi"
function* postFdesRealTimeResult(action) {
  const getToken = (state) => state.user.informations.token;
  const getFormFields = (state) => state.fdes.form.fields;
  const getSimulationMode = (state) => state.fdes.simulationMode;
  const getMetadata = (state) => state.fdes.metadata;

  try {
    const token = yield select(getToken);
    const fields = yield select(getFormFields);
    const simulationMode = yield select(getSimulationMode);
    const metadata = yield select(getMetadata);
    const metadataList = Array.isArray(metadata) ? metadata : [];

    const affResType = metadataList.find(
      (e) => e.paramId === AFFICHAGERSLT,
    )?.defaultValue;

    const data = yield call(
      postFdesRealTimeResultCall,
      token,
      formatRealTimeFdesParametersPayload(
        fields,
        action.fdesId,
        simulationMode,
        affResType === "thermometer",
      ),
      action.api,
    );
    yield call(parseResponse, data, SAVE_FDES_FORM_SUCCESS);
    if (action.saveCalculAfter && action.calculId) {
      yield put({ type: UPDATE_CALCUL, calculId: action.calculId });
      yield put(clearRecalcAfterUpgrade());
    }
  } catch (error) {
    if (action.saveCalculAfter) {
      yield put(clearRecalcAfterUpgrade());
    }
    yield put({ type: SAVE_FDES_FORM_FAILED, error });
  }
}

function* postFdesUploadFile(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);
    const data = yield call(
      postFdesUploadFileCall,
      token,
      formatFilePayload(action.file),
    );
    const value = {
      value: data.url,
      label: data.url,
    };
    yield put(changeFdesParameterForm(action.paramId, value));
  } catch (error) {
    yield put({ type: POST_FDES_FILE_FAILED, error });
  }
}

function* saveFdesResult() {
  const getToken = (state) => state.user.informations.token;
  const getCalculName = (state) => state.fdes.calculName;
  const getProjectName = (state) => state.fdes.projectName;
  const getSimulationMode = (state) => state.fdes.simulationMode;
  const getFormFields = (state) => state.fdes.form.fields;
  const getUser = (state) => state.user.informations;
  const getCurrentFdesId = (state) => state.fdes.form.currentFdesId;
  const getCalculateId = (state) => state.fdes.calculateId;
  const getResults = (state) => state.fdes.results;
  const getAdditionalResults = (state) => state.fdes.additionalResults;
  const getSettings = (state) => state.fdes.settings;
  const getLocalConfigurator = (state) => state.configurator.localConfigurator;
  const getUserParametersGroups = (state) => state.fdes.userParametersGroups;
  const getCalculMetadata = (state) => state.calculs.calcul?.metadata;

  try {
    const token = yield select(getToken);
    const fields = yield select(getFormFields);
    const calculName = yield select(getCalculName);
    const projectName = yield select(getProjectName);
    const simulationMode = yield select(getSimulationMode);
    const currentFdesId = yield select(getCurrentFdesId);
    const calculateId = yield select(getCalculateId);
    const user = yield select(getUser);
    const results = yield select(getResults);
    const additionalResults = yield select(getAdditionalResults);
    const settings = yield select(getSettings);
    const localConfigurator = yield select(getLocalConfigurator);
    const userParametersGroups = yield select(getUserParametersGroups);
    const calculMetadata = yield select(getCalculMetadata);

    if (!calculName || calculName === "") {
      yield put({ type: ENABLE_RESULT_FORM_LOADER });
      yield call(
        toast.error,
        "Le nom de votre calcul doit être renseigné pour être enregistré.",
      );
    } else {
      const data = yield call(
        saveFdesResultCall,
        token,
        formatFdesResultParametersPayload(
          fields,
          currentFdesId,
          calculName,
          user,
          projectName,
          calculateId,
          results,
          additionalResults,
          settings,
          localConfigurator._id,
          simulationMode,
          userParametersGroups,
          calculMetadata,
        ),
      );
      if (data._id) {
        yield put(push(`/fdes/${data.productFamily.id}/${data._id}`));
      }
      yield call(parseResponse, data, SAVE_FDES_RESULT_SUCCESS);
      yield put(loadUserCalculs());
      yield call(toast.success, "Résultat enregistré");
    }
  } catch (error) {
    yield put({ type: SAVE_FDES_RESULT_FAILED, error });
  }
}

function* patchCalcul(action) {
  const getToken = (state) => state.user.informations.token;
  const getCalculName = (state) => state.fdes.calculName;
  const getProjectName = (state) => state.fdes.projectName;
  const getSimulationMode = (state) => state.fdes.simulationMode;
  const getFormFields = (state) => state.fdes.form.fields;
  const getUser = (state) => state.user.informations;
  const getCurrentFdesId = (state) => state.fdes.form.currentFdesId;
  const getResults = (state) => state.fdes.results;
  const getAdditionalResults = (state) => state.fdes.additionalResults;
  const getSettings = (state) => state.fdes.settings;
  const getLocalConfigurator = (state) => state.configurator.localConfigurator;
  const getUserParametersGroups = (state) => state.fdes.userParametersGroups;
  const getCalculMetadata = (state) => state.calculs.calcul?.metadata;

  try {
    const token = yield select(getToken);
    const fields = yield select(getFormFields);
    const calculName = yield select(getCalculName);
    const projectName = yield select(getProjectName);
    const simulationMode = yield select(getSimulationMode);
    const currentFdesId = yield select(getCurrentFdesId);
    const user = yield select(getUser);
    const results = yield select(getResults);
    const additionalResults = yield select(getAdditionalResults);
    const settings = yield select(getSettings);
    const localConfigurator = yield select(getLocalConfigurator);
    const userParametersGroups = yield select(getUserParametersGroups);
    const calculMetadata = yield select(getCalculMetadata);

    if (!calculName || calculName === "") {
      yield put({ type: ENABLE_RESULT_FORM_LOADER });
      yield call(
        toast.error,
        "Le nom de votre calcul doit être renseigné pour être enregistré.",
      );
    } else {
      const data = yield call(
        updateCalculCall,
        token,
        formatFdesResultParametersPayload(
          fields,
          currentFdesId,
          calculName,
          user,
          projectName,
          action.calculId,
          results,
          additionalResults,
          settings,
          localConfigurator._id,
          simulationMode,
          userParametersGroups,
          calculMetadata,
        ),
        action.calculId,
      );
      yield call(parseResponse, data, UPDATE_CALCUL_SUCCESS);
      // yield put(loadUserCalculs());
      yield call(toast.success, "Résultat enregistré");
    }
  } catch (error) {
    yield put({ type: UPDATE_CALCUL_FAILED, error });
  }
}

function* generateReports(action) {
  const getToken = (state) => state.user.informations.token;
  try {
    const token = yield select(getToken);
    yield put(enableReportsLoaders([action.userFdesId]));

    const resultGenerate = yield call(
      generateReportCall,
      token,
      formatGenerateReportPayload(action.userFdesId, [
        "pdf",
        ...(action.filesToGenerate.xml ? ["xml"] : []),
        ...(action.filesToGenerate.xmlInies ? ["inies"] : []),
        ...(action.filesToGenerate.xls ? ["xls"] : []),
      ]),
    );

    //if resultGenerate has .code and it's not 200, then it's an error
    if (resultGenerate.code && resultGenerate.code !== "200") {
      yield put(disableReportsLoaders());
      yield call(
        toast.error,
        `Erreur lors de la génération des exports: ${resultGenerate.message}`,
      );
      yield put({
        type: GENERATE_REPORTS_FAILED,
        error: resultGenerate.message,
      });
      return;
    }

    let failedGenerationsCount = 0;
    if (!resultGenerate.pdf) {
      failedGenerationsCount++;
      yield call(toast.error, `Erreur lors de la génération du pdf`);
    }
    if (action.filesToGenerate.xml && !resultGenerate.xml) {
      failedGenerationsCount++;
      yield call(toast.error, `Erreur lors de la génération du xml`);
    }
    if (action.filesToGenerate.xmlInies && !resultGenerate.inies) {
      failedGenerationsCount++;
      yield call(toast.error, `Erreur lors de la génération du xml INIES`);
    }
    if (action.filesToGenerate.xls && !resultGenerate.xls) {
      failedGenerationsCount++;
      yield call(toast.error, `Erreur lors de la génération du xls`);
    }

    if (failedGenerationsCount > 0) {
      throw new Error("Une ou plusieurs générations ont échoué");
    } else {
      yield call(toast.success, `Exports générés`);
    }

    yield put(disableReportsLoaders());

    if (action.folderId) {
      yield put(loadFolderCalculs(action.folderId));
    } else {
      yield put(loadUserCalculs());
    }

    yield put({
      type: GENERATE_REPORTS_SUCCESS,
      payload: {
        pdf: resultGenerate.pdf || null,
        xml: resultGenerate.xml || null,
        inies: resultGenerate.inies || null,
        xls: resultGenerate.xls || null,
        createdAt: new Date().toISOString(),
      },
    });
  } catch (error) {
    yield put(disableReportsLoaders());
    yield put({ type: GENERATE_REPORTS_FAILED, error });
  }
}

function* sendXmlToEDEC(action) {
  const getToken = (state) => state.user.informations.token;
  const getLocalConfigurator = (state) => state.configurator.localConfigurator;

  try {
    const token = yield select(getToken);
    const localConfigurator = yield select(getLocalConfigurator);

    const data = yield call(
      postEDECIntegrationProcess,
      token,
      formatEDECIntegrationProcessPayload(action.values, localConfigurator._id),
    );

    yield call(parseResponse, data, "SEND_XML_TO_EDEC_SUCCESS");
    yield call(
      toast.success,
      `Votre FDES a été transférée sur votre compte EDEC`,
    );
  } catch (error) {
    yield put({ type: "SEND_XML_TO_EDEC_FAILED", error });
  }
}

function* bulkGenerateReports(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);
    yield put(
      enableReportsLoaders(action.calculs.map((calcul) => calcul.id || "")),
    );

    const data = yield call(bulkGenerateReportsCall, token, action.calculs);

    yield put(disableReportsLoaders());

    if (action.folderId) {
      yield put(loadFolderCalculs(action.folderId));
    } else {
      yield put(loadUserCalculs());
    }

    yield call(parseResponse, data, BULK_GENERATE_REPORTS_SUCCESS);

    const succeededGenerations = data.filter((d) => d.success === true);
    const failedGenerations = data.filter((d) => d.success === false);
    if (succeededGenerations.length > 0) {
      yield call(
        toast.success,
        `Exports générés pour ${succeededGenerations.length} calcul(s)`,
      );
    }
    if (failedGenerations.length > 0) {
      failedGenerations.forEach((failure) => {
        if (failure.error) {
          toast.error(`Erreur pour le calcul ${failure.id} : ${failure.error}`);
        }
      });
    }
  } catch (error) {
    yield put(disableReportsLoaders());
    yield put({ type: BULK_GENERATE_REPORTS_FAILED, error });
  }
}

function triggerZipDownload(blob) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "exports.zip";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

function* bulkDownloadReports(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    yield put(enableDownloadReportsLoader());

    const data = yield call(
      bulkDownloadReportsCall,
      token,
      action.calculIds,
      action.types,
    );

    yield call(triggerZipDownload, data);

    yield put(disableDownloadReportsLoader());

    yield put({ type: BULK_DOWNLOAD_REPORTS_SUCCESS });
    yield call(toast.success, `Exports téléchargés`);
  } catch (error) {
    yield put(disableDownloadReportsLoader());
    yield put({ type: BULK_DOWNLOAD_REPORTS_FAILED, error });
  }
}

export const fdesSagas = [
  takeLatest(POST_FDES_FILE, postFdesUploadFile),
  takeLatest(GET_FDES_METADATA, getFdesMetaData),
  takeLatest(GET_FDES_METADATA_CALCUL_ROW, getFdesMetaDataCalculRow),
  takeLatest(LOAD_FDES_PARAMETERS, getFdesParameters),
  takeLatest(SAVE_FDES_FORM, postFdesResult),
  takeLatest(SAVE_FDES_FORM_REAL_TIME, postFdesRealTimeResult),
  takeLatest(SAVE_FDES_RESULT, saveFdesResult),
  takeLatest(UPDATE_CALCUL, patchCalcul),
  takeLatest(LOAD_REFERENCE, getReferences),
  takeLatest(GENERATE_REPORTS, generateReports),
  takeEvery(SEND_XML_TO_EDEC, sendXmlToEDEC),
  takeEvery(BULK_GENERATE_REPORTS, bulkGenerateReports),
  takeEvery(BULK_DOWNLOAD_REPORTS, bulkDownloadReports),
];
